import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

// Services
import { postAcceptPost, postRefusePost } from '../../../../services/post/postService';

// Hooks
import useSearchParams from '../../../../hooks/useSearchParams';
import usePost from '../../../../hooks/domain/usePost';
import useToast from '../../../../hooks/useToast';

const useListSubView = (postListQuery) => {
  const { t } = useTranslation();
  const toast = useToast();
  const { updateSearchParams } = useSearchParams();
  const { getSlotsIdFromDate } = usePost();

  const acceptPostMutation = useMutation({
    mutationFn: postAcceptPost,
    onSuccess: () => {
      toast.notify({
        type: 'success',
        message: t('remoteWorkingAndLeave.listSubView.table.acceptSuccess'),
      });
      postListQuery.refetch();
    },
  });
  const refusePostMutation = useMutation({
    mutationFn: postRefusePost,
    onSuccess: () => {
      toast.notify({
        type: 'success',
        message: t('remoteWorkingAndLeave.listSubView.table.refuseSuccess'),
      });
      postListQuery.refetch();
    },
  });

  // Handlers
  const handleFilterChange = (fieldName, fieldValue) => {
    if (fieldName === 'includedStartSlotId') {
      const dateObject = new Date(fieldValue);
      return updateSearchParams({
        year: dateObject.getFullYear(),
        [fieldName]: getSlotsIdFromDate(dateObject).startSlotId,
      }, true);
    }

    if (fieldName === 'excludedEndSlotId') {
      const dateObject = new Date(fieldValue);
      return updateSearchParams({
        year: dateObject.getFullYear(),
        [fieldName]: getSlotsIdFromDate(dateObject).endSlotId + 1,
      }, true);
    }

    return updateSearchParams({ [fieldName]: fieldValue }, true);
  };

  const handleResetFilterClick = () => updateSearchParams({
    status: null,
    includedStartSlotId: null,
    excludedEndSlotId: null,
    resourceId: null,
    type: null,
  }, true);

  return {
    acceptPostMutation,
    refusePostMutation,
    handleFilterChange,
    handleResetFilterClick,
  };
};

export default useListSubView;
